/**
 * @file コンポーネント：フル動画ページシェーマポップアップ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Popup } from "~/src/components/projects/Popup";
import { Slider } from "~/src/components/uiparts/Slider";

// スタイル読み込み
import { StyledPopup, StyledSliderImage } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <Popup
            content={[
                <StyledPopup key={props.contentKey}>
                    {props.popupSchemaSlider && props.clickedSlideIndex && (
                        <Slider
                            arrows={true}
                            defaultIndex={Number(props.clickedSlideIndex)}
                            dots={true}
                            list={props.popupSchemaSlider.map((slide, i) => (
                                <StyledSliderImage
                                    alt=""
                                    key={"slide-" + i}
                                    src={slide.fileUrl}
                                />
                            ))}
                            zoom={true}
                        />
                    )}
                </StyledPopup>,
            ]}
            isOpen={props.isOpenPopupSchema}
            setIsOpen={props.setIsOpenPopupSchema}
        />
    );
};
